import { isTrulyEqual } from '../helpers/utils'

const frequencyCountMapping = {
  FQT01: 1,
  FQT02: 2,
  FQT03: 4,
  FQT04: 12,
  FQT05: 365,
  FQT06: 48
}

const validateSTT01 = (structure, frequencyOptions, appraisalTypeCode) => {
  let structureIsInvalid = false
  let sum = 0

  // Check if to stage is null
  if (isNaN(parseFloat(structure.stage_id))) {
    structureIsInvalid = true
  }

  // Start validate result items (Detail Panel)
  structure.result_item.forEach(item => {
    // Sum weight
    sum += +item.weight_percent || 0

    // Every item must have a frequency type
    if (isNaN(parseFloat(item.frequency_type_id))) {
      structureIsInvalid = true
    }

    // Grab frequency type and count (result kpi count must equal to frequencyCount)
    // Rules FQT01 = 1, FQT02 = 2, FQT03 = 4, FQT04 = 12, FQT05 = 365, FQT06 = 48
    const frequencyType = frequencyOptions.find(
      freq => freq.value_list_id === item.frequency_type_id
    )
    const frequencyCount = frequencyCountMapping[frequencyType?.value_list_code] || 99

    // Validate all result kpis
    structureIsInvalid = structureIsInvalid || validateSTT01Items(item.result_kpi, frequencyCount)

    // If appraisal type = Corporate, responsible must exists
    if (isNaN(parseFloat(item.responsible_id)) && appraisalTypeCode === 'APT01' && !item.is_adopt) {
      structureIsInvalid = true
    }

    // All items must have weight
    if (isNaN(parseFloat(item.weight_percent)) || +item.weight_percent < 0) {
      structureIsInvalid = true
    }
  })

  // Sum Weight must equal to 100
  if (!isTrulyEqual(+sum, 100)) {
    structureIsInvalid = true
  }

  // Every structure must have end date
  if (!structure.end_date) {
    structureIsInvalid = true
  }

  return structureIsInvalid
}

const validateSTT02 = structure => {
  let structureIsInvalid = false
  let sum = 0

  // Check if to stage is null
  if (isNaN(parseFloat(structure.stage_id))) {
    structureIsInvalid = true
  }

  // Start validate result items (Detail Panel)
  structure.result_item.forEach(item => {
    // Sum weight
    sum += +item.weight_percent || 0

    // All items must have weight
    if (isNaN(parseFloat(item.weight_percent)) || +item.weight_percent < 0) {
      structureIsInvalid = true
    }

    // All items must have target value
    // if (isNaN(parseFloat(item.target_value))) {
    //   structureIsInvalid = true
    // }
  })

  // Sum Weight must equal to 100
  if (!isTrulyEqual(+sum, 100)) {
    structureIsInvalid = true
  }

  // Every structure must have end date
  if (!structure.end_date) {
    structureIsInvalid = true
  }

  return structureIsInvalid
}

const validateSTT03 = structure => {
  let structureIsInvalid = false
  // Check if to stage is null
  if (isNaN(parseFloat(structure.stage_id))) {
    structureIsInvalid = true
  }

  // It should have one or more result_item
  if (!structure.result_item.length) {
    structureIsInvalid = true
  }

  // Every structure must have end date
  if (!structure.end_date) {
    structureIsInvalid = true
  }

  return structureIsInvalid
}

const validateSTT04 = (structure, frequencyOptions, appraisalTypeCode) => {
  let structureIsInvalid = false

  // Check if to stage is null
  if (isNaN(parseFloat(structure.stage_id))) {
    structureIsInvalid = true
  }

  // Start validate result items (Detail Panel)
  structure.result_item.forEach(item => {
    // Every item must have a frequency type
    if (isNaN(parseFloat(item.frequency_type_id))) {
      return true
    }

    // Removed (as of requirement to skip result kpi checking) [16-06-2020]
    // Grab frequency type and count (result kpi count must equal to frequencyCount)
    // Rules FQT01 = 1, FQT02 = 2, FQT03 = 4, FQT04 = 12, FQT05 = 365, FQT06 = 48
    // const frequencyType = frequencyOptions.find(
    //   freq => freq.value_list_id === item.frequency_type_id
    // )
    // const frequencyCount = frequencyCountMapping[frequencyType?.value_list_code] || 99

    // Validate all result kpis
    // structureIsInvalid = validateSTT04Items(item.result_kpi, frequencyCount)
    structureIsInvalid = false

    // If appraisal type = Corporate, responsible must exists
    if (isNaN(parseFloat(item.responsible_id)) && appraisalTypeCode === 'APT01' && !item.is_adopt) {
      structureIsInvalid = true
    }
  })

  // Every structure must have end date
  if (!structure.end_date) {
    structureIsInvalid = true
  }

  return structureIsInvalid
}

const validateSTT05 = structure => {
  let structureIsInvalid = false
  let sum = 0

  // Check if to stage is null
  if (isNaN(parseFloat(structure.stage_id))) {
    structureIsInvalid = true
  }

  // Start validate result items (Detail Panel)
  Object.entries(structure.result_item).forEach(group => {
    const [, groupAttrs] = group
    // const items = groupAttrs.items
    // Sum weight
    sum += +groupAttrs.weight_percent || 0

    // All items must have target value
    // const someItemsHasNoTargetValue = items.some(item => isNaN(parseFloat(item.target_value)))
    // if (someItemsHasNoTargetValue) {
    //   structureIsInvalid = true
    // }
  })

  // Sum Weight must equal to 100
  if (!isTrulyEqual(+sum, 100)) {
    structureIsInvalid = true
  }

  // Every structure must have end date
  if (!structure.end_date) {
    structureIsInvalid = true
  }

  return structureIsInvalid
}

const validateSTT06 = structure => {
  let structureIsInvalid = false

  // Check if to stage is null
  if (isNaN(parseFloat(structure.stage_id))) {
    structureIsInvalid = true
  }

  // Check if frequency_type_id is null
  if (isNaN(parseFloat(structure.frequency_type_id))) {
    structureIsInvalid = true
  }

  // Every structure must have end date
  if (!structure.end_date) {
    structureIsInvalid = true
  }

  return structureIsInvalid
}

const validateSTT01Items = (resultKpis, frequencyCount) => {
  // Check if result kpi is null or undefined
  if (!resultKpis) {
    return true
  }

  // Result kpi length must equal to selected frequency count
  // Rules FQT01 = 1, FQT02 = 2, FQT03 = 4, FQT04 = 12, FQT05 = 365, FQT06 = 48
  if (resultKpis.length !== frequencyCount) {
    return true
  }

  // Validate all result kpis. If any kpi result is invalid
  return resultKpis.every(kpiResult => {
    // Check all keys (except: result_kpi_id, result_item_id, actual_value) if is has a value
    return !Object.entries(kpiResult).reduce((isValid, result) => {
      const [resultKey, resultValue] = result
      if (['target_value'].includes(resultKey)) {
        return isValid && `${resultValue}` !== ''
      }
      return isValid
    }, true)
  })
}

// eslint-disable-next-line
const validateSTT04Items = (resultKpis, frequencyCount) => {
  // Check if result kpi is null or undefined
  if (!resultKpis) {
    return true
  }

  // Result kpi length must equal to selected frequency count
  // Rules FQT01 = 1, FQT02 = 2, FQT03 = 4, FQT04 = 12, FQT05 = 365, FQT06 = 48
  if (resultKpis.length !== frequencyCount) {
    return true
  }

  // Validate all result kpis. If any kpi result is invalid
  // return resultKpis.some(kpiResult => {
  // Check target_value if is has a value
  //   return !kpiResult.target_value || `${kpiResult.target_value}` === ''
  // })
}

export const validateStructure = (
  structure,
  structureTypeCode,
  appraisalTypeCode,
  frequencyOptions
) => {
  switch (structureTypeCode) {
    case 'STT01':
      return !validateSTT01(structure, frequencyOptions, appraisalTypeCode)
    case 'STT02':
      return !validateSTT02(structure)
    case 'STT03':
      return !validateSTT03(structure)
    case 'STT04':
      return !validateSTT04(structure, frequencyOptions, appraisalTypeCode)
    case 'STT05':
      return !validateSTT05(structure)
    case 'STT06':
      return !validateSTT06(structure)
    default:
      return false
  }
}
